import PropTypes from 'prop-types';

import { useState, useReducer, useEffect, createContext } from 'react';
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

const initialState = {
  isAuthenticated: true,
  isInitialized: false,
  userID: null,
  userRole: null,
  userFirstName: null,
  userLastName: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, userID, userRole, userFirstName, userLastName } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      userID,
      userRole,
      userFirstName,
      userLastName,
    };
  },
  LOGIN: (state, action) => {
    const { userID, userRole, userOrganisations, userFirstName, userLastName } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      userID,
      userRole,
      userFirstName,
      userLastName,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    userID: null,
    userRole: null,
    userFirstName: null,
    userLastName: null,
  }),
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
});

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');

        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);

          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              userID: window.localStorage.getItem('userID'),
              userRole: window.localStorage.getItem('userRole'),
              userFirstName: window.localStorage.getItem('userFirstName'),
              userLastName: window.localStorage.getItem('userLastName'),
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              userID: null,
              userRole: null,
              userFirstName: null,
              userLastName: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            userID: null,
            userRole: null,
            userFirstName: null,
            userLastName: null,
          },
        });
      }
    };
    initialize();
  }, []);

  const login = async (email, password) => {
    const response = await axios.post('/users/login/', {
      email,
      password,
    });

    console.log('RESPONSE', response);

    const { access, refresh, userID, userRole, userFirstName, userLastName } = response.data;

    setSession(access);

    window.localStorage.setItem('userID', userID);
    window.localStorage.setItem('userRole', userRole);
    window.localStorage.setItem('userFirstName', userFirstName);
    window.localStorage.setItem('userLastName', userLastName);

    dispatch({
      type: 'LOGIN',
      payload: {
        userID,
        userRole,
        userFirstName,
        userLastName,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
